import Pin from "pin";
import I2C from "i2c";
import EventTarget from "eventtarget";
import CustomEvent from "customevent";

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

const PIN_CLOCK = 27;
const PIN_PULSE = 22;
const BOUNCE_TIME = 30;


class UPSPICO extends EventTarget {
  static POWERMODE_CABLE = 1
static POWERMODE_BATTERY = 2
__pinClock = null
__pinPulse = null
__bus6B = null
__bus6D = null
__bus69 = null
constructor() {
  super();
}
async open() {
  /* setup I2C buses */
  this.__bus6B = new I2C();
  this.__bus6D = new I2C();    
  this.__bus69 = new I2C();  //status registers
  await this.__bus6B.open("/dev/i2c-1", 0x6B);
  await this.__bus6D.open("/dev/i2c-1", 0x6D);
  await this.__bus69.open("/dev/i2c-1", 0x69);
}
async start() {
  /*setup clock and pulse pins */
  this.__pinClock = new Pin("/sys/class/gpio", PIN_CLOCK);
  this.__pinPulse = new Pin("/sys/class/gpio", PIN_PULSE);

  /* wait until the operating systems sets up the pin */
  await sleep(1000);

  this.__pinPulse.direction = 0;
  this.__pinClock.direction = 1;
  this.__pinClock.onclear = this.__onchange_handler.bind(this);

}
async stop() {
  this.__pinClock.onclear = null;
  await this.__bus6B.close();
  await this.__bus6D.close();
  await this.__bus69.close();
}
async setLEDOrange(value) {
  /* this is a bug, first we have to invert to and then set */
  await this.__bus6B.writeByteData(0x09, !value ? 0x01 : 0x00);

  await this.__bus6B.writeByteData(0x09, value ? 0x01 : 0x00);
}
async setLEDGreen(value) {
  /* this is a bug, first we have to invert to and then set */
  await this.__bus6B.writeByteData(0x0A, !value ? 0x01 : 0x00);

  await this.__bus6B.writeByteData(0x0A, value ? 0x01 : 0x00);
}
async setLEDBlue(value) {
  /* this is a bug, first we have to invert to and then set */
  await this.__bus6B.writeByteData(0x0B, !value ? 0x01 : 0x00);

  await this.__bus6B.writeByteData(0x0B, value ? 0x01 : 0x00);
}
async getLEDOrange() {
  return await this.__bus6B.readByteData(0x09);
}
async getLEDGreen() {
  return await this.__bus6B.readByteData(0x0A);
}
async getLEDBlue() {
  return await this.__bus6B.readByteData(0x0B);
}
async beep(ms, hz=440) {
  /* Activate permanently the buzzer (default value) */
  await this.__bus6D.writeByte(0x01);

  /* Frequency of sound in Hz - word data*/
  await this.__bus6B.writeWordData(0x0E, hz);

  /* Duration of sound in 10th of ms (10 = 100 ms) */
  await this.__bus6B.writeByteData(0x10, Math.round(ms/10));
}
async getUserButtonsState() {
  return await this.__bus69.readByteData(0x1A);
}
async clearUserButtonsState() {
  await this.__bus69.writeByteData(0x1A, 0x00);
}
async __onchange_handler() {
  /* 
     dont do any i2c communication here, because if you have 2 threads for upspico for example 1 for signaling raspberry uptime and 1 for 
     i2c communication, then i2c communication will be confused
  */
  var value = this.__pinPulse.value;
  this.__pinPulse.value = 0;
  this.__pinPulse.direction = 1;
  if (this.__pinPulse.value == 0) {
    var event = new CustomEvent("onshutdown", {detail: null});
    this.dispatchEvent(event);
  }

  this.__pinPulse.direction = 0;
  this.__pinPulse.value = !value;

}
async setRelayState(value) {
  await this.__bus6B.writeByteData(0x0C, value ? 0x01 : 0x00);
}
async getRelayState() {
  return await this.__bus6B.readByteData(0x0C);
}
async getBatteryType() {
  var type = await this.__bus6B.readByteData(0x07);
  if (type==0x43) type=0x50;
  return type;
}
async setBatteryType(type) {
  /*
    0x46 – LiFePO4 (ASCII : F) used in version Stack/TopEnd
    0x51 – LiFePO4 (ASCII: Q) used in version Plus
    0x53 – LiPO (ASCII: S) used in version Stack/TopEnd
    0x50 – LiPO (ASCII: P) used in version Plus  
    
    LiFePO4: 3.65V charged (low: 2.5V)
    LiPO: 4.2V charged  (low: 3.5V)
  */
  await this.__bus6B.writeByteData(0x07, type);
}
async getPowerMode() {
  var mode = await this.__bus69.readByteData(0x00);
  /* we are interested only in the 2 low bits.
       0x01 - RPI_MODE (means cable powering mode USB or EPR)
       0x02 - BAT_MODE
  */
  return mode;
}
async getFirmwareVersion() {
  return await this.__bus69.readByteData(0x26);
}
async getBootloaderVersion() {
  return await this.__bus69.readByteData(0x25);
}
async getPCBVersion() {
  return await this.__bus69.readByteData(0x24);
}
async getBatteryVoltage() {
  var word = await this.__bus69.readWordData(0x08);
  var str = word.toString(16);
  return (parseFloat(str) / 100);
}
async getSystemVoltage() {
  var word = await this.__bus69.readWordData(0x0A);
  var str = word.toString(16);
  return (parseFloat(str) / 100);
}
async getExternalVoltage() {
  var word = await this.__bus69.readWordData(0x0C);
  var str = word.toString(16);
  return (parseFloat(str) / 100);
}
async getBatteryPercentage() {
  var datavolts = await this.getBatteryVoltage();
  var databattery = await this.getBatteryType();
  var datapercentage, databatminus;

  if ((databattery == 0x46) || (databattery == 0x51)) {
    /* LiFePO4 Battery, peak voltage = 3.65V, low: 2.5V */
    databatminus = datavolts-2.5;
    /* getBatteryVoltage returns only 1 decimal precision, so 3.6-2.5=1.1 */
    datapercentage = ((databatminus/1.1))*100;      
  } else if ((databattery == 0x53) || (databattery == 0x50)) {
    /* LiPO Battery, peak voltage = 4.2V, low: 3.5V */
    databatminus = datavolts-3.5;
    datapercentage = ((databatminus/0.7))*100;
  }
  return datapercentage;
}
async getNTCTemperature() {
  var byte = await this.__bus69.readByteData(0x1B);
  var lbyte = (byte & 0b00001111).toString(10);
  byte = byte>>>4;   
  var hbyte = (byte & 0b00001111).toString(10);
  return parseInt(hbyte+lbyte);
}
async getTO92Temperature() {
  var byte = await this.__bus69.readByteData(0x1C);
  var lbyte = (byte & 0b00001111).toString(10);
  byte = byte>>>4;   
  var hbyte = (byte & 0b00001111).toString(10);
  return parseInt(hbyte+lbyte);
}
/* Battery Run-Time in minues                                                     */
/* After this period of time an onshutdown event will be fired by the hardware    */
/* 0 = disable                                                                    */
/* if the user would like to use seconds granulatiry then he have to implement it */
/* for example by polling getPowerMode()                                          */
async setBatteryRunTime(min) {
  /* on hardware level 0xFF means no limit(only battery voltage is the limit), other values mean => 60[sec] + min*60[sec] */
  await this.__bus6B.writeByteData(0x01, min ? 0xFF : min-1);
}
async getBatteryRunTime() {
  var batteryRunTime = await this.__bus6B.readByteData(0x01);
  if (batteryRunTime==0xFF) return 0;
  return batteryRunTime++;
}
}

export default UPSPICO;